module.exports = __webpack_public_path__ + "static/media/Thank_u.26db65dc.png";